<!-- PAGE HEADER -->
<div class="page-header">
    <h2>Replace W-9</h2>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<div class="container pt-24">

    <form [formGroup]="replaceW9Form">
        <div class="border-box">
            <div class="required-note">
                By uploading a current and completed IRS Form W-9 (“W-9ˮ), the submitting business,
                organization, or individual certifies that the information provided
                is true, correct, and complete, and that they are authorized to act on behalf of the
                entity identified on the form. Submission of a W-9 serves as
                verification of the submitterʼs association with, and authority to represent, the
                named
                business or organization.
            </div>
            <div class="required-note">
                Knowingly providing false, fictitious, or fraudulent information on a W-9 is a
                violation
                of U.S. federal law. Falsifying or misrepresenting taxpayer
                identification information may subject the individual or entity to civil penalties,
                criminal penalties, or both, including fines and potential prosecution
                under applicable federal statutes.
            </div>
            <div class="required-note">
                By submitting a W-9, the submitter acknowledges these responsibilities and legal
                obligations.
            </div>
            <div class="row">

                <div class="field col-12 md:col-6">
                    <label><span>* </span>Accepted files: pdf or jpg with a maximum file size of 5 MB</label>
                    <div class="upload-container">
                        <button type="button" class="upload-btn" (click)="triggerFileSelect()">
                            Browse for File
                        </button>
                    </div>

                    <p-fileUpload #fileUploadRef mode="advanced" name="file" [multiple]="false" [auto]="false"
                        accept=".pdf,.jpg,.jpeg" [maxFileSize]="5242880" [customUpload]="true"
                        (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove($event)"
                        (onError)="onFileError($event)" [showUploadButton]="false" [showCancelButton]="false">

                        <ng-template pTemplate="header"></ng-template>

                    </p-fileUpload>

                    <small class="p-error" *ngIf="replaceW9Form.get('w9File')?.invalid &&
           replaceW9Form.get('w9File')?.touched">
                        File is required
                    </small>
                </div>
            </div>
        </div>



        <div class="actions mt-30">
            <button type="button" (click)="cancel()">
                Cancel
            </button>

            <button type="submit" (click)="confirmReplace()" [disabled]="!isFileValid || fileSizeError">
                Submit
            </button>
        </div>

    </form>
</div>

<!-- CONFIRMATION DIALOG -->
<p-dialog header="Warning" [(visible)]="showReplaceConfirm" [modal]="true" [closable]="false" [dismissableMask]="false"
    [style]="{ width: '400px' }">

    <div class="dialog-body">
        Submitting the uploaded file will replace the existing IRS Form W-9.
        Are you sure you want to do this?
    </div>

    <ng-template pTemplate="footer">
        <div class="actions">
            <button type="button" class="button-secondary" (click)="showReplaceConfirm = false">
                Cancel
            </button>

            <button type="button" class="button-primary" (click)="submitReplaceW9()">
                Continue
            </button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="{{ dialogSummary }}"
    [styleClass]="dialogSummary === 'Success' ? 'success-dialog' : 'success-dialog error'" [(visible)]="modalDlg"
    [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
    [breakpoints]="{ '640px': '95vw' }">

    <div class="dialog-body" [innerHTML]="dialogMsg"></div>

    <ng-template pTemplate="footer">
        <div class="actions">

            <!-- SUCCESS / ERROR BUTTON -->
            <ng-container>
                <button type="button" class="button-primary" (click)="okClicked()">
                    Ok
                </button>
            </ng-container>

        </div>
    </ng-template>
</p-dialog>